
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("ffPxZ", function(module, exports) {

$parcel$export(module.exports, "TeamCalendarNavigation", () => $791fef1c51edfb0f$export$a6737a3266096156);
/* TeamCalendarNavigation.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $cGtPE = parcelRequire("cGtPE");

var $3gadb = parcelRequire("3gadb");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $1NBp8 = parcelRequire("1NBp8");

var $jmjWc = parcelRequire("jmjWc");
var $luv00 = parcelRequire("luv00");

var $61vzn = parcelRequire("61vzn");

var $ep3mz = parcelRequire("ep3mz");

var $bQm3c = parcelRequire("bQm3c");

var $euL71 = parcelRequire("euL71");

var $1ytiN = parcelRequire("1ytiN");
const $791fef1c51edfb0f$var$styles = {
    root: "_2rko1l7b _4bfu1r81 _1hmsagmp _ajmmvv82 _1rjcze3t _bozgu2gc _y4ti1b66 _4t3i14no _1tke14no _1wybdlk8 _bfhk18uv _6ehmu2gc _syaz1gjq _9h8h1gjq _f8pj1gjq _10531gjq _tx28idpf _f1531tcg _o2hc1tcg _vd4fgktf _10wwgktf _1l9sgktf _13lwgktf _g512gktf _1iyggktf _irr3166n",
    isSelected: "_bfhkfg4m _syazaqb7 _9h8haqb7 _f8pjaqb7 _1053aqb7 _irr3i1yw"
};
const $791fef1c51edfb0f$var$listStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.0'
});

const $791fef1c51edfb0f$var$CalendarIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KFWHm",
    name: "CalendarIcon",
    loader: async ()=>(await (parcelRequire("h2pwJ"))).CalendarIcon
});
const $791fef1c51edfb0f$var$i18nTooltips = (0, $2nPZH.defineMessages)({
    calendarsTooltip: {
        id: "side-navigation.space-navigation.calendars.tooltip",
        defaultMessage: "View calendar"
    }
});
const $791fef1c51edfb0f$var$TeamCalendarNavigationComponent = ({ isSelected: isSelected, onClick: onClick })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        position: "top",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $791fef1c51edfb0f$var$i18nTooltips.calendarsTooltip)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            as: "li",
            xcss: $791fef1c51edfb0f$var$listStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cGtPE.default), {
            key: "calendars",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($791fef1c51edfb0f$var$CalendarIcon, {
                isSelected: isSelected
            }),
            isSelected: isSelected,
            href: (0, $1NBp8.SPACE_CALENDARS).toUrl({
                spaceKey: spaceKey
            }),
            ...tooltipProps,
            onClick: onClick,
            testId: "space-navigation-calendars-link",
            UNSAFE_shouldDisableRouterLink: true,
            "data-vc": "team-calendar-navigation",
            ...ssrPlaceholderIdProp,
            className: (0, $35pXk.default)([
                $791fef1c51edfb0f$var$styles.root,
                isSelected && $791fef1c51edfb0f$var$styles.isSelected
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            id: "side-navigation.container.calendars",
            defaultMessage: "Calendars"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $61vzn.PremiumLozengeLoadable), null))));
};
const $791fef1c51edfb0f$export$a6737a3266096156 = (props)=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext)); // Please also update getPremiumFeaturesWebItemKeys() in SpaceNavigation if this condition is updated
    /**
   * showTCNav:
   * - Premium -> true, TC is a premium feature
   * - Standard -> true, iff user is Org/Site Admin, otherwise, false (https://hello.atlassian.net/wiki/spaces/CE2/pages/3031965072/ETC+Standard+P18N+Technical+Spec)
   * - Free -> true, TC upsell to all Free users (https://hello.atlassian.net/wiki/spaces/CE2/pages/2906634153/ETC+P18N+Technical+Spec)
   */ const showTCNav = edition === (0, $euL71.ConfluenceEdition).STANDARD ? isSiteAdmin : true;
    return showTCNav ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($791fef1c51edfb0f$var$TeamCalendarNavigationComponent, props) : null;
};

});
parcelRegister("61vzn", function(module, exports) {

$parcel$export(module.exports, "TrialFlags", () => $5e8e088fe72e4df1$export$c108f21945b8b79);
$parcel$export(module.exports, "PremiumLozengeLoadable", () => $5e8e088fe72e4df1$export$62673719cbe80cd0);
$parcel$export(module.exports, "ReverseTrialLozengeExperiment", () => $5e8e088fe72e4df1$export$b51195909514673e);
$parcel$export(module.exports, "ReverseTrialLozengeListItemExperiment", () => $5e8e088fe72e4df1$export$e82a504f7cb45e99);
$parcel$export(module.exports, "PremiumLozengeImage", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("leRtl")))));

var $gwFzn = parcelRequire("gwFzn");

var $dIouf = parcelRequire("dIouf");

var $jmjWc = parcelRequire("jmjWc");

var $leRtl = parcelRequire("leRtl");

const $5e8e088fe72e4df1$var$TrialFlagsLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "pBDfE",
    name: "TrialFlagsLoadable",
    loader: async ()=>(await (parcelRequire("hfSv4"))).TrialFlags
});
const $5e8e088fe72e4df1$export$c108f21945b8b79 = (0, $dIouf.withErrorBoundary)({
    attribution: (0, $dIouf.Attribution).GROWTH_LUNA
})(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($5e8e088fe72e4df1$var$TrialFlagsLoadable, null));

const $5e8e088fe72e4df1$export$62673719cbe80cd0 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Txnkb",
    name: "PremiumLozengeLoadable",
    loader: async ()=>(await (parcelRequire("lhVPO"))).PremiumLozenge
});

const $5e8e088fe72e4df1$export$b51195909514673e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EHgbD",
    name: "ReverseTrialLozengeExperiment",
    loader: async ()=>(await (parcelRequire("3Fb82"))).ReverseTrialLozengeWithErrorBoundary
});

const $5e8e088fe72e4df1$export$e82a504f7cb45e99 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "DLH6o",
    name: "ReverseTrialLozengeListItemExperiment",
    loader: async ()=>(await (parcelRequire("c4EN7"))).ReverseTrialListItemWithErrorBoundary
});

});
parcelRegister("leRtl", function(module, exports) {
module.exports = new URL("premiumLozenge.aa9b0435.svg", import.meta.url).toString();

});

parcelRegister("hfSv4", function(module, exports) {

let $c8fe1cfbeff454a9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c8fe1cfbeff454a9$var$load("cmcKh"),
    $c8fe1cfbeff454a9$var$load("ktyyJ")
]).then(()=>parcelRequire('1VYG6'));

});

parcelRegister("lhVPO", function(module, exports) {

let $f7f80c459b873240$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f7f80c459b873240$var$load("4yUSc").then(()=>parcelRequire('9xi4O'));

});

parcelRegister("3Fb82", function(module, exports) {

let $2aadd5555486ad95$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $2aadd5555486ad95$var$load("joJy8"),
    $2aadd5555486ad95$var$load("aHE9G"),
    $2aadd5555486ad95$var$load("fqBFU")
]).then(()=>parcelRequire('gQsLh'));

});

parcelRegister("c4EN7", function(module, exports) {

let $8ca58009917cc373$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $8ca58009917cc373$var$load("fqBFU"),
    $8ca58009917cc373$var$load("joJy8"),
    $8ca58009917cc373$var$load("aHE9G"),
    $8ca58009917cc373$var$load("1HAEl")
]).then(()=>parcelRequire('f3FIN'));

});


parcelRegister("h2pwJ", function(module, exports) {

let $c6766cb4aa59ab80$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c6766cb4aa59ab80$var$load("ffEVr"),
    $c6766cb4aa59ab80$var$load("aZ9pO")
]).then(()=>parcelRequire('dntIc'));

});



//# sourceMappingURL=TeamCalendarNavigation.955f9217.js.map
